import  utils from '@/utils';
export function matchFileLogo(type) {
  const nType = type.toUpperCase();
  const logoArr = [
    "DOC",
    "DOCX",
    "KEY",
    "PDF",
    "PGS",
    "PPT",
    "PPTX",
    "TXT",
    "WPS",
  ];
  // 'XLS', 'XLSX','JPG','PNG','GIF','BMP','TIF','TIFF','ZIP','RAR','RAR5','RARX',''
  if (logoArr.includes(nType)) {
    return require(`@/assets/${nType}.png`);
  } else {
    return require("@/assets/default_docs.png");
  }
}

export function showTime(value) {
  if (typeof value == "undefined" || value == null || value == "") {
    return "-";
  }
  return utils.formatDate(new Date(value), "yyyy-MM-dd hh:mm:ss");
}

export function saveFile(res,name){
    let objectUrl = res
    const blob = new Blob([res.data], {});
    objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    //定义文件名,
    a.download = name;
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl)
}
